// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement, Component, createPortal, isValidElement, cloneElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `Layer` component.
 */
class Layer extends Component {
    getChildContext() {
        const { parentLayer } = this.context;
        const { level } = this.props;
        const parentLevel = parentLayer ? parentLayer.level : 0;

        return {
            parentLayer: {
                level: parentLevel + level,
            },
        };
    }

    renderChildren({ children, level }) {
        const { parentLayer } = this.context;
        const parentLevel = parentLayer ? parentLayer.level : 0;

        if (isValidElement(children)) {
            return cloneElement(children, {
                style: { ...children.props.style, zIndex: parentLevel + level },
            });
        }

        return children;
    }

    render() {
        const {
            baseClassName,
            className,
            children,
            innerRef,
            level,
            ...props
        } = this.props;

        return createPortal(
            <div
                className={classNames(baseClassName, className)}
                ref={innerRef}
                {...props}
            >
                {this.renderChildren({ children, level })}
            </div>,
            document.body,
        );
    }
}

Layer.propTypes = {
    /**
     * Content of the `Layer`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    innerRef: PropTypes.func,
    /**
     * Level.
     */
    level: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Layer.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}layer`,
    innerRef: null,
    level: null,
};

Layer.childContextTypes = {
    parentLayer: PropTypes.shape({
        level: PropTypes.number,
    }),
};

Layer.contextTypes = {
    parentLayer: PropTypes.shape({
        level: PropTypes.number,
    }),
};

export default Layer;



// WEBPACK FOOTER //
// ./components/Layer/Layer.js